import cn from 'classnames';
import { CheckCircle } from '#assets/ReactSvg.ts';
import { Banner } from '#components/atoms/banner/Banner.tsx';
import { Button } from '#components/atoms/buttons/Button.tsx';
import type { Domain } from '#dn-types/domain.ts';
import styles from './EnablePromptBanner.module.css';

type Props = {
  providerName: string;
  domain: Domain;
  isEnabling: boolean;
  onEnable: () => void;
  onDismiss: () => void;
  className?: string;
};

export function EnablePromptBanner({ providerName, domain, isEnabling, onEnable, onDismiss, className }: Props) {
  return (
    <Banner
      variant="success"
      Icon={CheckCircle}
      iconClassName={cn('color-success', styles.EnablePromptBanner_icon)}
      className={className}
    >
      <div className={styles.EnablePromptBanner}>
        <div>
          <span className="weight-bold">
            {providerName} on {domain.domainName}
          </span>{' '}
          is verified and ready. Do you want to enable?
        </div>
        <div className={cn('flex align-center shrink-0', styles.EnablePromptBanner_buttons)}>
          <Button onClick={onDismiss} variant="link" size="xsmall">
            Keep disabled
          </Button>
          <Button variant="primary" size="xsmall" disabled={isEnabling} onClick={onEnable}>
            Enable provider
          </Button>
        </div>
      </div>
    </Banner>
  );
}
